import { DefaultRootState } from 'react-redux';

export const getId = (state: DefaultRootState) => {
  return state.card.common.id;
};

export const getUuid = (state: DefaultRootState) => {
  return state.card.common.uuid;
};

export const isShareableLink = (state: DefaultRootState) => {
  return state.card.common.isShareableLink;
};
